import inputFilled from './input-filled';
import fTextareaInit from './textarea';

document.addEventListener('DOMContentLoaded', () => {

    const btns = document.querySelectorAll('.js-add-textarea');
    btns.forEach((btn, index) => {

        btn.addEventListener('click',(e)=>{
            e.preventDefault();
            let count = btn.getAttribute('data-count');
            count++;
            const label = btn.getAttribute('data-label');
            const name = btn.getAttribute('data-name');
            btn.setAttribute('data-count', count);
            const parent = btn.parentNode;
            parent.insertAdjacentHTML('beforebegin', '<div class="form__line">\n' +
                '<textarea class="form__input form__input--textarea--small js-textarea" name="'+name+'-'+count+'" id="'+name+'-'+count+'" rows="1" cols="10"></textarea>\n' +
                '<label class="form__label" for="'+name+'-'+count+'">'+label+'</label>\n' +
                '</div>');

            const btnRemove = parent.querySelector('.js-del-textarea');
            btnRemove?.removeAttribute('disabled');

            inputFilled();
            fTextareaInit();

        });

    });

    const delBtns = document.querySelectorAll('.js-del-textarea');
    delBtns.forEach((btn, index) => {

        btn.addEventListener('click',(e)=>{
            e.preventDefault();
            const parent = btn.parentNode;
            const btnAdd = parent.querySelector('.js-add-textarea');
            let count = btnAdd.getAttribute('data-count');
            if(count>1){
                count--;
                btnAdd.setAttribute('data-count', count);
                const formLine = parent.previousElementSibling;
                formLine?.remove();
            }
            if(count=="1"){
                btn.setAttribute('disabled','disabled');
            }


        });

    });

});
